/**
 * Solution Visibility Configuration Utilities
 * 
 * Simplified - no caching, always returns true
 * Module visibility is controlled by pipeline through uiConfigUtils.js
 * This layer is kept for backward compatibility but always allows visibility
 */

/**
 * Check if a specific solution should be visible in navbar
 * Always returns true - visibility is controlled by uiConfigUtils.js
 * @param {string} solutionKey - Key of the solution (drDashboard, em, wnt, etc.)
 * @returns {boolean} Always true
 */
export const isSolutionVisible = (solutionKey) => {
  return true;
};

/**
 * Get solution visibility - always returns all visible
 * @returns {Promise<Object>} All solutions visible
 */
export const getSolutionVisibility = async () => {
  return {
    drDashboard: true,
    em: true,
    wnt: true,
    cybershield: true,
    prooferTool: true,
    cognien: true,
    evciEds: true,
    solarEnergy: true,
    netZero: true
  };
};

/**
 * Get solution visibility synchronously - always returns all visible
 * @returns {Object} All solutions visible
 */
export const getSolutionVisibilitySync = () => {
  return {
    drDashboard: true,
    em: true,
    wnt: true,
    cybershield: true,
    prooferTool: true,
    cognien: true,
    evciEds: true,
    solarEnergy: true,
    netZero: true
  };
};

/**
 * Deprecated - No-op function for backward compatibility
 */
export const saveSolutionVisibility = async (config) => {
  console.warn('saveSolutionVisibility is deprecated - visibility controlled by pipeline');
  return true;
};

/**
 * Deprecated - No-op function for backward compatibility
 */
export const buildSolutionVisibilityFromConfig = (backendConfig) => {
  return getSolutionVisibilitySync();
};

/**
 * Deprecated - No-op function for backward compatibility
 */
export const hasSolutionVisibilityConfig = () => {
  return false;
};

/**
 * Deprecated - No-op function for backward compatibility
 */
export const clearSolutionVisibility = () => {
  console.warn('clearSolutionVisibility is deprecated');
};
